export abstract class KeyValueStorageStrategy {
  public abstract initStore(storeName: string, tableNames: Array<string>): Promise<void>;
  public abstract getItem<T>(key: string, tableName: string): Promise<T | undefined>;
  public abstract setItem(key: string, value: unknown, tableName: string): Promise<void>;
  public abstract removeItem(key: string, tableName: string): Promise<void>;
  public abstract getItems<T = unknown>(tableName: string): Promise<Array<T>>;
  public abstract setItems<T = unknown>(items: Array<Item<T>>, tableName: string): Promise<void>;
  public abstract removeItems(keys: Array<string>, tableName: string): Promise<void>;
  public abstract clear(tableName: string): Promise<void>;
}
export type Item<T> = {
  key: string;
  value: T;
};